module.exports = __webpack_public_path__ + "media/images/hinthealth_logo-4b059110cbb73028a921402e31316db2.svg";